module.exports = __webpack_public_path__ + "static/sport/h5out6.fe28eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/h5out6.png
// module id = uaIq
// module chunks = 0